var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Errors } from "../toolkit.config";
import { getAuthHeaders, getErrorMessage } from "../utils/index";
/**
 * @function fetchJsonContentMetadata
 * @description **fetches JSON response for paragraph used in dynamic content.**
 * - in dynamic content, a new paragraph type can be added.
 * - a exising paragraph type can be removed.
 * @param {string} url - JSON endpoint for the content type without media parameters.
 * @returns {Promise<object>} promise of JSON response for the content type without media endpoints.
 */
export const fetchJsonContentMetadata = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(url, {
        headers: yield getAuthHeaders(),
    });
    if (!response.ok) {
        throw new Error(getErrorMessage(Errors.DTK001001));
    }
    const jsonData = (yield response.json());
    return jsonData;
});
/**
 * @function fetchJsonContent
 * @description **fetches JSON response for paragraph content and media content.**
 * - the content and media are fetched in a single request.
 * @param  {string} url - JSON endpoint for the content type with media parameters.
 * @returns {Promise<object>} promise of JSON response for the content type with media endpoints.
 */
export const fetchJsonContent = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(url, {
        headers: yield getAuthHeaders(),
    });
    if (!response.ok) {
        throw new Error(getErrorMessage(Errors.DTK001002));
    }
    const jsonData = (yield response.json());
    return jsonData;
});
/**
 * @function fetchJsonMenu
 * @description **fetches JSON response for menu.**
 * - the menu is fetched in a single request.
 * - this does not use JSON API module.
 * @param {string} url - JSON endpoint for the menu.
 * @returns {Promise<object>} promise of JSON response for the menu.
 */
export const fetchJsonMenu = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(url, {
        headers: yield getAuthHeaders(),
    });
    if (!response.ok) {
        throw new Error(getErrorMessage(Errors.DTK001003));
    }
    const jsonData = (yield response.json());
    return jsonData;
});
